import React from "react";
import ct from "class-types.macro";

const SpecialOrders = () => {
  return (
    <>
      <div
        className={ct(
          "bg-transparent",
          "border-none",
          "box-border",
          "mt-0",
          "mb-5",
          "lt:bg-white",
          "lt:border-gray-200",
          "lt:rounded",
          "lt:border-solid",
          "lt:border"
        )}
      >
        <a href="/special-orders/">
          <img
            alt="Contact Special Orders"
            src="https://cdnimg.webstaurantstore.com/uploads/design/2016/1/moreparts.png"
          />
        </a>
      </div>
    </>
  );
};

export default SpecialOrders;
